module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_fondo_14.3778b335.png";